const translation = {
  // Navigation
  nav_home: "Startseite",
  nav_categories: "Kategorien",
  nav_routes: "Routen",
  nav_map: "Karte",
  nav_for_business: "Mein Betrieb",
  nav_explore_btn: "Entdecken",
  nav_cat_historical: "Historische Stätten",
  nav_cat_food: "Essen & Trinken",
  nav_cat_entertainment: "Unterhaltung",
  nav_cat_accommodation: "Unterkunft",
  nav_cat_nature: "Natur & Routen",
  nav_cat_sightseeing: "Sehenswürdigkeiten",
  nav_cat_featured: "Empfohlene Orte",

  // Hero
  hero_badge: "Das grüne Paradies der Türkei",
  hero_title_1: "Bursa",
  hero_title_2: "360°",
  hero_title_3: "Entdecken",
  hero_subtitle: "Historische Bauten, Naturschönheiten, kulinarische Highlights — der ultimative Guide durch Bursa.",
  hero_search_placeholder: "Orte, Kategorien oder Routen suchen...",
  hero_search_btn: "Suchen",
  hero_stat_1_num: "500+",
  hero_stat_1_label: "Orte zu entdecken",
  hero_stat_2_num: "85+",
  hero_stat_2_label: "Gastronomiebetriebe",
  hero_stat_3_num: "12",
  hero_stat_3_label: "Fertige Routen",
  hero_stat_4_num: "4.8",
  hero_stat_4_label: "Durchschnittsbewertung",
  hero_quick_label: "Schnellzugriff:",
  hero_quick_history: "Historisches",
  hero_quick_food: "Essen",
  hero_quick_nature: "Natur",
  hero_quick_hotels: "Hotels",
  hero_quick_fun: "Spaß",

  // Categories section
  cat_section_badge: "Kategorien",
  cat_section_title: "Was möchten Sie entdecken?",
  cat_section_subtitle: "Von historischen Stätten bis zu Naturrouten, Gastronomie bis Unterkunft — alles hier.",
  cat_historical_title: "Historische Stätten",
  cat_historical_desc: "Osmanisches Erbe, UNESCO-Stätten und historische Orte",
  cat_historical_count: "120+ Orte",
  cat_food_title: "Essen & Trinken",
  cat_food_desc: "Iskender, Fleischbällchen und Bursas einzigartige Aromen",
  cat_food_count: "85+ Restaurants",
  cat_entertainment_title: "Unterhaltung",
  cat_entertainment_desc: "Abenteurerparks, Aktivitäten und Nachtleben",
  cat_entertainment_count: "60+ Orte",
  cat_accommodation_title: "Unterkunft",
  cat_accommodation_desc: "Boutique-Hotels, Thermalbäder und Ferienorte",
  cat_accommodation_count: "200+ Optionen",
  cat_nature_title: "Natur & Routen",
  cat_nature_desc: "Uludağ, Seen, Wanderwege und Naturtouren",
  cat_nature_count: "40+ Routen",
  cat_sightseeing_title: "Sehenswürdigkeiten",
  cat_sightseeing_desc: "Museen, Basare, Dörfer und Panoramapunkte",
  cat_sightseeing_count: "95+ Orte",
  cat_featured_title: "Empfohlene Orte",
  cat_featured_desc: "Die besten Adressen unserer Redakteure",
  cat_featured_count: "Redakteursauswahl",
  cat_view_all: "Alle anzeigen",

  // Featured section
  featured_badge: "Empfohlen",
  featured_title: "Empfehlungen dieser Woche",
  featured_subtitle: "Die meistgeliebten Adressen unserer Redakteure und Besucher.",
  featured_view_all: "Alle Orte anzeigen",
  featured_sponsored: "Gesponsert",
  featured_editor: "Redakteursauswahl",
  featured_open: "Geöffnet",
  featured_closed: "Geschlossen",
  featured_details: "Details",
  featured_directions: "Route",
  featured_km_away: "km entfernt",
  featured_reviews: "Bewertungen",

  // Routes section
  routes_badge: "Fertige Routen",
  routes_title: "Bursa planen",
  routes_subtitle: "Expertenkurierte Routenvorschläge — je nach Zeit und Interesse.",
  routes_view_all: "Alle Routen",
  routes_hours: "Std.",
  routes_stops: "Stopps",
  routes_start: "Route starten",
  routes_difficulty_easy: "Leicht",
  routes_difficulty_medium: "Mittel",
  routes_difficulty_hard: "Schwer",
  routes_day1_title: "Bursa an einem Tag",
  routes_day1_desc: "Entdecken Sie die ikonischsten Orte der Stadt an einem einzigen Tag",
  routes_history_title: "Historische Bursa-Route",
  routes_history_desc: "Eine umfassende Geschichtstour auf osmanischen Spuren",
  routes_food_title: "Genussroute",
  routes_food_desc: "Erkunden Sie Bursas beste Aromen den ganzen Tag",
  routes_family_title: "Familienroute",
  routes_family_desc: "Eine spaßige und entspannte Bursa-Tour für Kinder und Familien",
  routes_weekend_title: "Wochenendplan",
  routes_weekend_desc: "Ein umfassendes 2-tägiges Bursa-Erlebnis",

  // Nearby section
  nearby_badge: "Für Sie",
  nearby_title: "Beste Stopps in Ihrer Nähe",
  nearby_subtitle: "Empfehlungen aus verschiedenen Kategorien in Ihrer Nähe.",
  nearby_location_btn: "Meinen Standort verwenden",
  nearby_using_location: "Standort wird ermittelt...",
  nearby_view_all: "Mehr anzeigen",
  nearby_km_away: "km entfernt",
  nearby_permission_title: "Orte in der Nähe anzeigen",
  nearby_permission_desc: "Teilen Sie Ihren Standort und wir zeigen Ihnen sofort die nächsten historischen Stätten, Restaurants und Hotels.",
  nearby_no_permission: "Standortzugriff verweigert. Bitte in den Browsereinstellungen erlauben.",

  // Campaigns section
  campaigns_badge: "Angebote",
  campaigns_title: "Kampagnen & Rabatte",
  campaigns_subtitle: "Exklusive Angebote und Gutscheine in Bursas besten Einrichtungen.",
  campaigns_view_all: "Alle Kampagnen",
  campaigns_expires: "Gültig bis",
  campaigns_get_coupon: "Gutschein holen",
  campaigns_sponsored: "Gesponsert",
  campaigns_discount: "Rabatt",

  // Chatbot
  chatbot_title: "Bursa-Assistent",
  chatbot_subtitle: "Fragen Sie nach Routen und Orten",
  chatbot_greeting: "Hallo! Was möchten Sie in Bursa unternehmen? Ich helfe Ihnen gerne mit den besten Routen und Empfehlungen.",
  chatbot_placeholder: "Etwas fragen...",
  chatbot_send: "Senden",
  chatbot_suggestion_1: "Was kann ich heute tun?",
  chatbot_suggestion_2: "Beste historische Orte",
  chatbot_suggestion_3: "Route vorschlagen",
  chatbot_suggestion_4: "Wohin mit Kindern?",
  chatbot_suggestion_5: "Beste Restaurants",

  // Footer
  footer_tagline: "Entdecken Sie Bursa 360°",
  footer_desc: "BursaGuide360 ist eine umfassende digitale Stadtführer-Plattform für alle Bursa-Besucher.",
  footer_links_title: "Schnelllinks",
  footer_categories_title: "Kategorien",
  footer_contact_title: "Kontakt",
  footer_address: "Osmangazi, Bursa, Türkei",
  footer_phone: "+90 224 000 0000",
  footer_email: "info@bursaguide360.com",
  footer_rights: "© 2026 BursaGuide360. Alle Rechte vorbehalten.",
  footer_privacy: "Datenschutzrichtlinie",
  footer_terms: "Nutzungsbedingungen",
  footer_for_business: "Für Betriebe",
  footer_newsletter_title: "Bursa-News",
  footer_newsletter_desc: "Als Erstes über neue Orte und Kampagnen informiert werden.",
  footer_newsletter_placeholder: "Ihre E-Mail-Adresse",
  footer_newsletter_btn: "Abonnieren",

  // Common
  common_open: "Geöffnet",
  common_closed: "Geschlossen",
  common_sponsored: "Gesponsert",
  common_featured: "Empfohlen",
  common_editor_pick: "Redakteursauswahl",
  common_view_details: "Details anzeigen",
  common_get_directions: "Route abrufen",
  common_book_now: "Jetzt buchen",
  common_explore: "Entdecken",
  common_see_all: "Alle anzeigen",
  common_km_away: "km entfernt",

  // QR
  qr_badge: "Willkommen!",
  qr_title: "Die ersten 5 Dinge",
  qr_title_accent: "nach dem Hotel-Check-out",
  qr_desc: "5 Empfehlungen für Ihre ersten Stunden in Bursa.",
  qr_item1_title: "Zu Extrempark fahren",
  qr_item1_desc: "Bester Aussichtspunkt der Stadt. Bergrodeln, Riesenschaukel und Aussichtsterrasse.",
  qr_item1_cta: "Ticket kaufen",
  qr_item2_title: "Grüne Moschee besuchen",
  qr_item2_desc: "10 Minuten vom Hotel — osmanische Fliesenkunst vom Feinsten.",
  qr_item2_cta: "Route",
  qr_item3_title: "Iskender Kebab essen",
  qr_item3_desc: "1867 in Bursa erfunden — die Identität der Stadt.",
  qr_item3_cta: "Ort sehen",
  qr_item4_title: "Seilbahn zum Uludağ",
  qr_item4_desc: "8 Minuten Panoramafahrt von der Stadt zum Gipfel.",
  qr_item4_cta: "Zeiten sehen",
  qr_item5_title: "Cumalıkızık erkunden",
  qr_item5_desc: "700 Jahre altes osmanisches Dorf. Steinhäuser und Nostalgie.",
  qr_item5_cta: "Auf Karte zeigen",
  qr_back: "Zum vollständigen Reiseführer",
  qr_powered: "Angetrieben von BursaGuide360",

  sticky_label: "Orte in der Nähe",
};

export default translation;
